<template>
  <router-view />
</template>

<script>
export default {
  watch: {
    $route() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style>
body {
  width: 100%;
  min-width: 320px;
  min-height: 100vh;
  line-height: 1.5;
  color: rgb(33, 33, 33);
  background-color: rgb(250, 250, 250);
}

a {
  color: rgb(117, 117, 117);
  cursor: pointer;
  text-decoration: underline;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

a:hover {
  color: rgba(107, 107, 107, 0.7);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.link {
  color: rgb(117, 117, 117);
  cursor: pointer;
  text-decoration: underline;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.link:hover {
  color: rgba(107, 107, 107, 0.7);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
</style>
